var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Tooltip as TooltipMaterial, Zoom, } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    tooltip: {
        fontSize: 12,
    },
}));
export default function Tooltip(_a) {
    var { title, children } = _a, props = __rest(_a, ["title", "children"]);
    const classes = useStyles();
    return React.createElement(TooltipMaterial, { classes: { tooltip: classes.tooltip }, title: title, TransitionComponent: Zoom, placement: "top", arrow: true }, children);
}
//# sourceMappingURL=index.js.map